import type { SectionLocale } from '../types'

export const EVENTS_LOCALE: SectionLocale = [
  [
    'event_delete_question',
    {
      ru: 'Вы уверены, что хотите удалить объявление?',
      en: 'Are you sure you want to delete this event?',
    },
  ],
  [
    'events_search_not_found',
    {
      ru: 'Объявления не найдены',
      en: 'Events not found',
    },
  ],
  [
    'events_search_placeholder',
    {
      ru: 'Поиск объявления',
      en: 'Search announcement',
    },
  ],
  [
    'events_sort_newest',
    {
      ru: 'Сначала новые',
      en: 'Newest first',
    },
  ],
  [
    'events_sort_oldest',
    {
      ru: 'Сначала старые',
      en: 'Oldest first',
    },
  ],
  [
    'events_add_item',
    {
      ru: 'Добавить объявление',
      en: 'Add announcement',
    },
  ],
  [
    'events_edit_item',
    {
      ru: 'Редактировать',
      en: 'Edit',
    },
  ],
  [
    'events_delete_item',
    {
      ru: 'Удалить',
      en: 'Delete',
    },
  ],
  [
    'events_edit_title',
    {
      ru: 'Заголовок объявления',
      en: 'Announcement title',
    },
  ],
  [
    'events_breadcrumb_add',
    {
      ru: 'Добавление',
      en: 'Add',
    },
  ],
  [
    'events_breadcrumb_edit',
    {
      ru: 'Редактирование',
      en: 'Edit',
    },
  ],
  [
    'events_create_page_title',
    {
      ru: 'Добавление объявления',
      en: 'Add announcement',
    },
  ],
  [
    'events_edit_page_title',
    {
      ru: 'Редактирование объявления',
      en: 'Edit announcement',
    },
  ],
  [
    'events_item_not_found',
    {
      ru: 'Объявление не найдено',
      en: 'Announcement not found',
    },
  ],
  [
    'events_submit_add',
    {
      ru: 'Добавить',
      en: 'Add',
    },
  ],
  [
    'events_location_all_countries',
    {
      ru: 'Все страны',
      en: 'All countries',
    },
  ],
  [
    'events_location_all_cities',
    {
      ru: 'Все города',
      en: 'All cities',
    },
  ],
  [
    'events_location_all_offices',
    {
      ru: 'Все офисы',
      en: 'All offices',
    },
  ],
  [
    'events_editor_toolbar',
    {
      ru: 'Панель форматирования текста',
      en: 'Text formatting toolbar',
    },
  ],
  [
    'events_editor_content_required',
    {
      ru: 'Введите текст объявления',
      en: 'Enter the announcement text',
    },
  ],
  [
    'events_editor_content_too_short',
    {
      ru: 'Текст объявления должен содержать не менее {min} символов',
      en: 'Announcement text must be at least {min} characters',
    },
  ],
  [
    'events_editor_content_too_long',
    {
      ru: 'Текст объявления не должен превышать {max} символов',
      en: 'Announcement text must not exceed {max} characters',
    },
  ],
]
